import { createContext, createRef, useContext, useRef } from "react";

export interface IAgTechAppPopUps {
    closeAll: () => void
}

export const DefaultAgTechPopUps: IAgTechAppPopUps = {
    closeAll: () => {
        console.error('Attempted to close all popups from default handler');
    }
}

/// Types

export type AgTechCoordinates = {
    x: number,
    y: number
};

export const DefaultAgTechCoordinate: AgTechCoordinates = {
    x: 0,
    y: 0
}

export enum AgTechPopUpPosition {
    Beside,
    BesideCentered,
    BelowCentered,
    BelowRight
}

export type AgTechPopUpCoreProps = {
    popup: () => React.ReactNode,
    config?: AgTechPopUpConfiguration,
    handlers?: AgTechPopUpEventHandlers
}

export type AgTechPopUpConfiguration = {
    position?: AgTechPopUpPosition,
    emphasizeShadow?: boolean,
    fadeInTime?: string,
    shouldCloseOnBlur?: boolean,
    shouldCloseOthersOnOpen?: boolean,
    topOffset?: number
}

export type AgTechPopUpEventHandlers = {
    onBeforePopUpOpened?: () => void,
    onPopUpOpened?: () => void,
    onPopUpClosed?: () => void
}

export type AgTechRenderedPopUp = {
    popupRef: React.RefObject<HTMLDivElement>,
    callerRef: React.MutableRefObject<any>,
    close: () => void,
    parent?: AgTechPopUpContext
}

export type AgTechPopUpRendering = {
    popupId: string,
    callerRef: React.RefObject<any>,
    popupRef: React.RefObject<HTMLDivElement>,
    popup: () => React.ReactNode,
    popupConfig?: AgTechPopUpConfiguration,
    closePopup: (popupId: string) => void,
    layer: AgTechPopUpLayer,
    parentPopUpContext: AgTechPopUpContext
}

export type AgTechPopUpLayer = {
    agtechLayer: number,
    popupLayer: number
}

/// Context

export type AgTechPopUpContext = {
    caller: React.MutableRefObject<any>,
    closePopUp: () => void,
    childPopUpContext?: AgTechPopUpContext,
    layer: AgTechPopUpLayer
}

export const PopUpContext = createContext<AgTechPopUpContext>({
    caller: createRef(),
    closePopUp: () => {},
    layer: { agtechLayer: 0, popupLayer: 0 }
});

export const useAgTechPopUpContext = () => useContext(PopUpContext);